<template>
  <div>
    <!-- Form -->
    <v-container grid-list-md>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <span class="title">{{ formTitle }} </span>
          </v-card-title>
          <v-form v-model="valid" ref="form" lazy-validation>
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-text-field
                      label="Category Name *"
                      v-model="formSchema.cat_name"
                      :rules="[v => !!v || 'Field is required']"
                    ></v-text-field>
                  </v-flex>

                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-autocomplete
                      label="Economic Code Name *"
                      item-text="eco_account_name"
                      item-value="id"
                      v-model="formSchema.economic_id"
                      :items="economicList"
                      @change="setName"
                      :rules="[v => !!v || 'Field is required']"
                    ></v-autocomplete>
                  </v-flex>

                  <v-flex xs12 sm6 md3 class="pr-4">
                    <v-text-field label="Economic Code *" v-model="formSchema.economic_code" readonly></v-text-field>
                  </v-flex>
                  <v-flex xs12 md3 sm3>
                    <v-checkbox
                      v-model="formSchema.is_active"
                      label="Active"
                      :value="isActiveVal"
                    ></v-checkbox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                class="success"
                flat
                v-if="userRole.saveButton || userRole.updateButton"
                @click.native="validateBeforeSubmit"
              >
                <v-icon>save</v-icon>
                {{ buttonTitle }}
              </v-btn>
              <v-btn class="info" flat @click.native="close({message:'Form Reseted !',status:1})">
                <v-icon>refresh</v-icon>Reset
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
    </v-container>
    <!-- /Form -->
  </div>
</template>


<script>
let commonService = require("../../../services/common.service");

export default {
  props: ["formSchema"],

  data: () => ({
    valid: true,
    isActiveVal: 1,
    roleList: [],
    economicList: []
  }),

  computed: {
    // Title Changes
    formTitle() {
      return this.formSchema.id > 0
        ? "Edit Asset Category"
        : "Add Asset Category";
    },
    buttonTitle() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    },

    // User Previlization methods
    userRole() {
      return this.$store.getters.get_USER_ROLE_DATA;
    }
  },

  created() {
    let root = this;
    commonService.getAllData("get_economic_info").then(res => {
      root.economicList = res.data;
    });
  },

  methods: {
    // Form submission methods================
    validateBeforeSubmit(e) {
      var formSchema = this.formSchema;
      var root = this;
      if (root.$refs.form.validate()) {
        if (formSchema.id > 0) {
          commonService
            .updateFormData(this.formSchema, "asset_category")
            .then(res => {
              res.action = "edit";
              this.close(res);
            });
        } else {
          commonService
            .insertFormData(this.formSchema, "asset_category")
            .then(res => {
              res.action = "add";
              this.close(res);
            });
        }
      }
    },

    // onchange economic code name selected
    setName() {
      var eco_id = this.formSchema.economic_id;
      var index = this.economicList
        .map(function(e) {
          return e.id;
        })
        .indexOf(eco_id);
      var economic_code = this.economicList[index].eco_account_code;
      this.formSchema.economic_code = economic_code;
    },

    // close: function Perform
    close: function(data) {
      if (data.status == 1) {
        this.$refs.form.reset();
        this.formSchema.id = 0;
      }
      this.$emit("emitForm", data);
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/asset/asset_category/asset_cat_form.vue